import { createFileRoute } from '@tanstack/react-router'
import { guardNoAccess, NoAccessPage } from '@pa/staff'

/** "You don't have access to this site." (Frontend §5.2): signed in, not a super admin. */
export const Route = createFileRoute('/no-access')({
  beforeLoad: ({ context }) => guardNoAccess(context, 'admin'),
  component: () => <NoAccessPage siteName="PF Appointments · Super admin" />,
})
